<app-navbar-side></app-navbar-side>

<app-header></app-header>

<div id="router-outlet-container">
  <router-outlet></router-outlet>
</div>

<yes-no-modal></yes-no-modal>